import { formatNumber } from "accounting"
import dayjs from "dayjs"

import { INCOGNITO_MASK } from "../../../Components/Private"
import Images from "../../../Images"
import { isIncognitoActive } from "../../../Utils/incognito"
import { formatCurrency, serviceImgTooltip } from "../../../Utils/utils"

const dateFormat = "MMM D, YYYY"

export const getChartOptions = (theme, type, period) => ({
  //type: descriptors or accounts
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    intersect: false
  },
  stacked: false,
  hover: {
    cursor: "pointer"
  },
  //make cursor pointer
  onHover: function (event, chartElement) {
    if (chartElement.length) {
      event.native.target.style.cursor = "pointer"
    } else {
      event.native.target.style.cursor = "default"
    }
  },
  plugins: {
    title: {
      display: false
    },
    tooltip: {
      enabled: false,
      // yAlign: 'bottom',
      // displayColors: false,
      // boxHeight: 200,
      callbacks: {
        title: (context) => {
          const dataIndex = context?.[0]?.dataIndex
          let data = null

          let totalCount = null
          let totalValue = null
          let itemsArrFinal

          if (type === "accounts") {
            data = context?.[0]?.dataset?.[type]?.[dataIndex]?.business_accounts
            totalCount = context?.[0]?.dataset?.[type]?.[dataIndex]?.total
            totalValue = context?.[0]?.dataset?.[type]?.[dataIndex]?.total_amount

            itemsArrFinal = data?.map((el) => ({
              [el.name]: {
                count: el.total,
                volume: el.total_amount
              }
            }))
          } else {
            data = context?.[0]?.dataset?.[type]

            let itemsList = Object.keys(data)

            let itemsArr = itemsList?.map((el) => {
              return { [el]: data[el][dataIndex] }
            })

            totalCount = itemsArr.reduce(
              (partialSum, el) => partialSum + (Object.values(el)?.[0]?.count || 0),
              0
            )
            totalValue = itemsArr.reduce(
              (partialSum, el) => partialSum + (Object.values(el)?.[0]?.volume || 0),
              0
            )

            itemsArrFinal = itemsArr
              ?.filter((el) => Object.values(el)?.[0]?.count)
              ?.sort((a, b) => Object.values(b)?.[0]?.count - Object.values(a)?.[0]?.count)
          }

          const formatCountVolume = (count, volume) =>
            isIncognitoActive()
              ? INCOGNITO_MASK
              : `${formatNumber(count, 0, ",")}` +
                '<span class="gray-circle"></span>' +
                `$${formatNumber(volume, 2, ",", ".")}`

          let itemsShowArr = []
          if (Array.isArray(itemsArrFinal) && itemsArrFinal.length > 0) {
            itemsShowArr = itemsArrFinal?.map((el) => {
              return (
                `<div>${Object.keys(el)}:</div>` +
                `<div style="padding-left: 8px">${formatCountVolume(
                  Object.values(el)?.[0]?.count,
                  Object.values(el)?.[0]?.volume
                )}</div>`
              )
            })
          }

          return [
            `${context?.[0].label}`,
            "Total:" + '<span class="space-10"></span>' + formatCountVolume(totalCount, totalValue),
            ...itemsShowArr
          ]
        }
      },
      external: function (context) {
        const dataPoints = context.tooltip.dataPoints?.[0]
        // Tooltip Element
        let tooltipEl = document.getElementById("chartjs-tooltip_descriptor")

        // Create element on first render
        if (!tooltipEl) {
          tooltipEl = document.createElement("div")
          tooltipEl.id = "chartjs-tooltip_descriptor"
          let styleTable = "width: 100%;"
          tooltipEl.innerHTML = '<table style="' + styleTable + '" ></table>'
          // need clear charts custom tooltip element from body of page (because it can not remove on other pages automatically)
          //this logic see in initComponent
          document.body.appendChild(tooltipEl)
        }
        // Hide if no tooltip
        const tooltipModel = context.tooltip
        if (tooltipModel.opacity === 0 && !tooltipEl.matches(":hover")) {
          tooltipEl.style.opacity = 0
          if (tooltipEl._hideOnTouchOutside) {
            document.removeEventListener("touchstart", tooltipEl._hideOnTouchOutside)
            tooltipEl._hideOnTouchOutside = null
          }
          return
        }

        // Set caret Position
        tooltipEl.classList.remove("above", "below", "no-transform")
        if (tooltipModel.yAlign) {
          tooltipEl.classList.add(tooltipModel.yAlign)
        } else {
          tooltipEl.classList.add("no-transform")
        }

        const width = 270

        tooltipEl.style.zIndex = "10"
        tooltipEl.style.backgroundColor = "#27272A"
        tooltipEl.style.borderRadius = "12px"
        tooltipEl.style.padding = "12px 12px"
        tooltipEl.style.color = "white"
        tooltipEl.style.minWidth = width + "px"
        tooltipEl.style.maxHeight = "220px"

        // Set Text
        if (tooltipModel.body) {
          const titleLines = tooltipModel.title || []

          let innerHtml = "<thead>"
          let styleTitle =
            "padding-bottom: 0px; text-align: start; font-weight: 500; color: #7A7A83"
          let styleTitle2 =
            "padding: 0px; padding-top: 12px; padding-bottom: 12px; font-weight: 400; text-align: start"
          let styleTitle3 = "padding: 0px; padding-top: 4px; font-weight: 400; text-align: start;"

          titleLines.forEach(function (value, i) {
            if (i === 0) {
              innerHtml += '<tr><th style="' + styleTitle + '" >' + value + "</th></tr>"
            }
            if (i === 1) {
              innerHtml += '<tr><th style="' + styleTitle2 + '" >' + value + "</th></tr>"
            }
            if (i > 1) {
              innerHtml +=
                '<tr><th style="' +
                styleTitle3 +
                '"><div class="descriptor-flex">' +
                value +
                "</div></th></tr>"
            }
          })

          innerHtml += "</thead><tbody>"

          let tableRoot = tooltipEl.querySelector("table")
          tableRoot.innerHTML = innerHtml
        }

        const position = context.chart.canvas.getBoundingClientRect()
        // const bodyFont = Chart.helpers.toFont(tooltipModel.options.bodyFont);

        // Display, position, and set styles for font
        tooltipEl.style.opacity = 1
        tooltipEl.style.position = "absolute"

        let tooltipWidth = tooltipEl?.offsetWidth
        let deltaLeft = tooltipWidth / 2
        if (dataPoints?.chart.width - tooltipModel.caretX <= tooltipWidth / 2) {
          deltaLeft = tooltipWidth * 0.85
        } else if (tooltipModel.caretX < tooltipWidth / 2) {
          deltaLeft = tooltipWidth * 0.15
        }

        const tooltipHeight1 = tooltipEl?.offsetHeight || 200
        let left1 = position.left - deltaLeft + window.scrollX + tooltipModel.caretX
        let top1 = position.top - (tooltipHeight1 + 20) + window.scrollY + tooltipModel.caretY
        left1 = Math.max(
          window.scrollX,
          Math.min(left1, window.scrollX + window.innerWidth - tooltipEl.offsetWidth)
        )
        top1 = Math.max(
          window.scrollY,
          Math.min(top1, window.scrollY + window.innerHeight - tooltipHeight1)
        )
        tooltipEl.style.left = left1 + "px"
        tooltipEl.style.top = top1 + "px"
        // tooltipEl.style.font = bodyFont.string;
        tooltipEl.style.padding = tooltipModel.padding + "px "
        tooltipEl.style.overflow = "auto"
        tooltipEl.style.pointerEvents = "auto"

        if (!tooltipEl._hideOnTouchOutside) {
          const canvas = context.chart.canvas
          tooltipEl._hideOnTouchOutside = (e) => {
            if (!canvas.contains(e.target) && !tooltipEl.contains(e.target)) {
              tooltipEl.style.opacity = 0
              document.removeEventListener("touchstart", tooltipEl._hideOnTouchOutside)
              tooltipEl._hideOnTouchOutside = null
            }
          }
          document.addEventListener("touchstart", tooltipEl._hideOnTouchOutside, { passive: true })
        }
      }
    },
    legend: {
      display: false
    }
  },
  scales: {
    x: {
      type: "time",
      time: {
        unit: period === "7 days" ? "day" : "week", // 'week' or 'day' or 'hour'
        displayFormats: {
          hour: "hh a",
          day: "MMM DD",
          week: "MMM DD",
          month: "MMM DD",
          quarter: "MMM DD",
          year: "MMM"
        },
        tooltipFormat: "MMM DD, YYYY"
      },
      grid: {
        drawOnChartArea: false,
        tickColor: "transparent"
      },
      border: {
        display: false
      },
      ticks: {
        font: {
          size: 12,
          weight: 400
        }
      }
    },
    y: {
      type: "linear",
      display: true,
      position: "left",
      beginAtZero: true,
      grid: {
        color: theme === "dark" ? "rgba(255, 255, 255, 0.12)" : "#E1E1E2",
        tickColor: "transparent"
      },
      border: {
        display: false,
        dash: [4, 4]
      },
      ticks: {
        maxTicksLimit: 6,
        font: {
          size: 12
        },
        callback: function (value, index, values) {
          if (isIncognitoActive()) return INCOGNITO_MASK
          if (value >= 1000) {
            return value / 1000 + "k"
          } else {
            return value
          }
        }
      }
    }
  },
  datasets: {
    line: {
      pointRadius: 0,
      lineTension: 0.4
    }
  }
})

export const baseOptions = (theme) => ({
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    intersect: false
  },
  stacked: false,
  hover: {
    cursor: "pointer"
  },
  onHover: function (event, chartElement) {
    if (chartElement.length) {
      event.native.target.style.cursor = "pointer"
    } else {
      event.native.target.style.cursor = "default"
    }
  },
  scales: {
    x: {
      type: "time",
      time: {
        unit: "day", // 'week' or 'day' or 'hour'
        displayFormats: {
          hour: "hh a",
          day: "MMM DD",
          week: "MMM DD",
          month: "MMM DD",
          quarter: "MMM DD",
          year: "MMM"
        },
        tooltipFormat: "MMM DD, YYYY"
      },
      grid: {
        drawOnChartArea: false,
        tickColor: "transparent"
      },
      border: {
        display: false
      },
      ticks: {
        font: {
          size: 12,
          weight: 400
        }
      }
    },
    y: {
      type: "linear",
      display: true,
      position: "left",
      beginAtZero: true,
      grid: {
        color: theme === "dark" ? "rgba(255, 255, 255, 0.12)" : "#E1E1E2",
        tickColor: "transparent"
      },
      border: {
        display: false,
        dash: [4, 4]
      },
      ticks: {
        maxTicksLimit: 6,
        font: {
          size: 12
        },
        callback: function (value) {
          if (value >= 1000) {
            return value / 1000 + "k"
          } else {
            return value
          }
        }
      }
    }
  },
  datasets: {
    line: {
      pointRadius: 0, // disable for all `'line'` datasets
      lineTension: 0.25
    }
  }
})

export const alertsChartOptions = (theme) => ({
  ...baseOptions(theme),
  scales: {
    ...baseOptions(theme).scales,
    y: {
      ...baseOptions(theme).scales.y,
      ticks: {
        ...baseOptions(theme).scales.y.ticks,
        callback: function (value) {
          if (isIncognitoActive()) return INCOGNITO_MASK
          if (value >= 1000) return value / 1000 + "k"
          return value
        }
      }
    }
  },
  plugins: {
    title: {
      display: false
    },
    tooltip: {
      enabled: false,
      // yAlign: 'bottom',
      // displayColors: false,
      // boxHeight: 200,
      callbacks: {
        title: (context) => {
          const dataIndex = context?.[0]?.dataIndex
          const ds = context?.[0]?.chart?.data?.datasets?.[0] || context?.[0]?.dataset
          const total = ds?.total?.[dataIndex]
          const ethoca = ds?.ethoca?.[dataIndex]
          const rdr = ds?.rdr?.[dataIndex]
          const cdrn = ds?.cdrn?.[dataIndex]
          const compTotal = ds?.comparisonTotal?.[dataIndex]
          const rawCompDate = ds?.comparisonLabels?.[dataIndex]
          const compDate = rawCompDate ? dayjs(rawCompDate).format(dateFormat) : null
          const compLabel = ds?.comparisonLabel || "previous period"
          const selectType = ds?.selectType
          const localFormatNumber = (value) => {
            if (isIncognitoActive()) return INCOGNITO_MASK
            if (selectType === "volume") {
              return `$${formatNumber(value, 2, ",", ".")}`
            } else {
              return `${formatNumber(value, 0, ",", ".")}`
            }
          }

          const rawMainDate = ds?.mainLabels?.[dataIndex] ?? context?.[0].label
          const mainDate = rawMainDate ? dayjs(rawMainDate).format(dateFormat) : ""
          const lines = [
            `${mainDate}`,
            `Total: ${localFormatNumber(total)}`,
            `Ethoca <span style="float: right; padding-left: 8px">${localFormatNumber(
              ethoca
            )}</span>`,
            `RDR <span style="float: right; padding-left: 8px">${localFormatNumber(rdr)}</span>`,
            `CDRN <span style="float: right; padding-left: 8px">${localFormatNumber(cdrn)}</span>`
          ]
          if (compTotal != null) {
            const capLabel = compLabel ? compLabel.charAt(0).toUpperCase() + compLabel.slice(1) : ""
            const leftLabel = compDate || capLabel
            lines.push(
              `__COMPARE__<span style="display:flex; justify-content:space-between; gap:24px; width:100%">` +
                `<span>${leftLabel}</span>` +
                `<span>${localFormatNumber(compTotal)}</span>` +
                `</span>`
            )
          }
          return lines
        }
      },
      external: function (context) {
        const dataPoints = context.tooltip.dataPoints?.[0]

        // Tooltip Element
        let tooltipEl = document.getElementById("chartjs-tooltip")

        // Create element on first render
        if (!tooltipEl) {
          tooltipEl = document.createElement("div")
          tooltipEl.id = "chartjs-tooltip"
          let styleTable = "width: 100%;"
          tooltipEl.innerHTML = '<table style="' + styleTable + '" ></table>'
          // need clear charts custom tooltip element from body of page (because it can not remove on other pages automatically)
          //this logic see in initComponent
          document.body.appendChild(tooltipEl)
        }
        // Hide if no tooltip
        const tooltipModel = context.tooltip
        if (tooltipModel.opacity === 0) {
          tooltipEl.style.opacity = 0
          if (tooltipEl._hideOnTouchOutside) {
            document.removeEventListener("touchstart", tooltipEl._hideOnTouchOutside)
            tooltipEl._hideOnTouchOutside = null
          }
          return
        }

        // Set caret Position
        tooltipEl.classList.remove("above", "below", "no-transform")
        if (tooltipModel.yAlign) {
          tooltipEl.classList.add(tooltipModel.yAlign)
        } else {
          tooltipEl.classList.add("no-transform")
        }

        const width = 154

        tooltipEl.style.zIndex = "1010"
        tooltipEl.style.backgroundColor = "#27272A"
        tooltipEl.style.borderRadius = "12px"
        tooltipEl.style.padding = "12px 12px"
        tooltipEl.style.color = "white"
        tooltipEl.style.minWidth = width + "px"
        // Set Text
        if (tooltipModel.body) {
          const titleLines = tooltipModel.title || []

          let innerHtml = "<thead>"
          let styleTitle =
            "padding-bottom: 0px; text-align: start; font-weight: 500; color: #7A7A83"
          let styleTitle2 =
            "padding: 0px; padding-top: 12px; padding-bottom: 12px; font-weight: 400; text-align: start"
          let styleTitle3 = "padding: 0px; padding-top: 4px; font-weight: 400; text-align: start;"

          const styleCompare =
            "padding: 8px 0 0; margin-top: 8px; border-top: 1px solid #3F3F46; font-weight: 400; text-align: start; color: #A1A1AA"
          titleLines.forEach(function (value, i) {
            const isCompare = typeof value === "string" && value.startsWith("__COMPARE__")
            if (isCompare) {
              const cleaned = value.replace("__COMPARE__", "")
              innerHtml += '<tr><th style="' + styleCompare + '" >' + cleaned + "</th></tr>"
              return
            }
            if (i === 0) {
              innerHtml += '<tr><th style="' + styleTitle + '" >' + value + "</th></tr>"
            }
            if (i === 1) {
              innerHtml += '<tr><th style="' + styleTitle2 + '" >' + value + "</th></tr>"
            }
            if (i === 2) {
              innerHtml +=
                '<tr><th style="' +
                styleTitle3 +
                '"><img src="' +
                Images[serviceImgTooltip[theme]["ethoca"]] +
                '" width="20" height="auto" style="margin-right: 8px;" alt="mastercard logo">' +
                value +
                "</th></tr>"
            }
            if (i >= 3 && i <= 4) {
              innerHtml +=
                '<tr><th style="' +
                styleTitle3 +
                '"><img src="' +
                Images[serviceImgTooltip[theme]["rdr"]] +
                '" width="20" height="auto" style="margin-right: 8px;" alt="virifi logo">' +
                value +
                "</th></tr>"
            }
          })
          innerHtml += "</thead><tbody>"

          let tableRoot = tooltipEl.querySelector("table")
          tableRoot.innerHTML = innerHtml
        }

        const position = context.chart.canvas.getBoundingClientRect()
        // const bodyFont = Chart.helpers.toFont(tooltipModel.options.bodyFont);

        // Display, position, and set styles for font
        tooltipEl.style.opacity = 1
        tooltipEl.style.position = "absolute"

        let tooltipWidth = tooltipEl?.offsetWidth
        let deltaLeft = tooltipWidth / 2
        if (dataPoints?.chart.width - tooltipModel.caretX <= tooltipWidth / 2) {
          deltaLeft = tooltipWidth * 0.75
        } else if (tooltipModel.caretX < tooltipWidth / 2) {
          deltaLeft = tooltipWidth * 0.25
        }

        const tooltipHeight2 = tooltipEl?.offsetHeight || 160
        let left2 = position.left - deltaLeft + window.scrollX + tooltipModel.caretX
        let top2 = position.top - (tooltipHeight2 + 20) + window.scrollY + tooltipModel.caretY
        left2 = Math.max(
          window.scrollX,
          Math.min(left2, window.scrollX + window.innerWidth - tooltipEl.offsetWidth)
        )
        top2 = Math.max(
          window.scrollY,
          Math.min(top2, window.scrollY + window.innerHeight - tooltipHeight2)
        )
        tooltipEl.style.left = left2 + "px"
        tooltipEl.style.top = top2 + "px"
        // tooltipEl.style.font = bodyFont.string;
        tooltipEl.style.padding = tooltipModel.padding + "px "
        tooltipEl.style.pointerEvents = "none"

        if (!tooltipEl._hideOnTouchOutside) {
          const canvas = context.chart.canvas
          tooltipEl._hideOnTouchOutside = (e) => {
            if (!canvas.contains(e.target)) {
              tooltipEl.style.opacity = 0
              document.removeEventListener("touchstart", tooltipEl._hideOnTouchOutside)
              tooltipEl._hideOnTouchOutside = null
            }
          }
          document.addEventListener("touchstart", tooltipEl._hideOnTouchOutside, { passive: true })
        }
      }
    },
    legend: {
      display: false
    }
  }
})

export const healthOverviewChartOptions = (theme) => ({
  ...baseOptions(theme),
  plugins: {
    "vertical-line-plugin-with-points": { theme: theme },
    title: {
      display: false
    },
    tooltip: {
      enabled: false,
      callbacks: {
        title: (context) => {
          const dataIndex = context?.[0]?.dataIndex
          const ds = context?.[0]?.chart?.data?.datasets?.[0] || context?.[0]?.dataset
          const selectType = ds?.selectType

          const isRate = selectType === "rate"
          const formatMain = (v) => {
            if (v == null) return "-"
            return isRate ? `${formatNumber(v, 2, ",", ".")}%` : formatNumber(v, 0, ",", ".")
          }
          // The chart line itself (rate / count) stays readable in Incognito mode; only the "$"
          // volume next to it is hidden (CHA1-1357).
          const formatVolume = (v) => {
            if (isIncognitoActive()) return INCOGNITO_MASK
            return v == null ? "-" : `$${formatNumber(v, 2, ",", ".")}`
          }

          const compLabel = ds?.comparison_label
          const capCompLabel = compLabel
            ? compLabel.charAt(0).toUpperCase() + compLabel.slice(1)
            : "Previous period"

          const rawMainDate = ds?.main_labels?.[dataIndex] ?? context?.[0].label
          const mainDate = rawMainDate ? dayjs(rawMainDate).format(dateFormat) : ""
          const rawCompDate = ds?.comparison_labels?.[dataIndex]
          const compDate = rawCompDate ? dayjs(rawCompDate).format(dateFormat) : capCompLabel

          const cellStyle = "display:flex; align-items:center; gap:12px; padding:2px 0;"
          const rightStyle =
            "margin-left:auto; display:flex; gap:12px; color:white; font-weight:500;"
          const indicatorStyle = (color, dashed) =>
            `display:inline-block; width:14px; height:0; border-top:2px ${
              dashed ? "dashed" : "solid"
            } ${color}; flex-shrink:0;`
          const sectionStyle = "font-weight:600; color:white; padding:8px 0 4px; font-size:13px;"
          const headerStyle = "font-weight:500; color:#7A7A83; padding-bottom:4px;"

          const chartTitle = isRate ? "Chargeback rate" : "Chargeback count"
          const lines = []
          lines.push(`__RAW__<div style="${headerStyle}">${chartTitle}</div>`)

          const buildRow = (color, dashed, label, mainValue, volumeValue) => {
            const right = isRate
              ? `<span>${formatMain(mainValue)}</span>`
              : `<span>${formatMain(mainValue)}</span><span>${formatVolume(volumeValue)}</span>`
            return (
              `__RAW__<div style="${cellStyle}">` +
              `<span style="${indicatorStyle(color, dashed)}"></span>` +
              `<span style="color:#D4D4D8;">${label}</span>` +
              `<span style="${rightStyle}">${right}</span>` +
              `</div>`
            )
          }

          // For main value we use with_us / without_us (which reflects
          // selected chart_type — rate or count). Volume ($) always shown.
          lines.push(`__RAW__<div style="${headerStyle}">${mainDate}</div>`)
          lines.push(
            buildRow(
              "#225AEA",
              false,
              "With us",
              ds?.with_us?.[dataIndex],
              ds?.with_us_volume?.[dataIndex]
            )
          )
          lines.push(
            buildRow(
              "#A1A1AA",
              true,
              "Without us",
              ds?.without_us?.[dataIndex],
              ds?.without_us_volume?.[dataIndex]
            )
          )

          const hasCompare = ds?.comparison_with_us != null || ds?.comparison_without_us != null
          if (hasCompare) {
            lines.push(`__RAW__<div style="${headerStyle} padding:8px 0 4px">${compDate}</div>`)
            lines.push(
              buildRow(
                "#F79009",
                false,
                "Prev. with us",
                ds?.comparison_with_us?.[dataIndex],
                ds?.comparison_with_us_volume?.[dataIndex]
              )
            )
            lines.push(
              buildRow(
                "#F79009",
                true,
                `Prev. without us`,
                ds?.comparison_without_us?.[dataIndex],
                ds?.comparison_without_us_volume?.[dataIndex]
              )
            )
          }
          return lines
        }
      },
      external: function (context) {
        const dataPoints = context.tooltip.dataPoints?.[0]

        // Tooltip Element
        let tooltipEl = document.getElementById("chartjs-tooltip-health")

        // Create element on first render
        if (!tooltipEl) {
          tooltipEl = document.createElement("div")
          tooltipEl.id = "chartjs-tooltip-health"
          let styleTable = "width: 100%;"
          tooltipEl.innerHTML = '<table style="' + styleTable + '" ></table>'
          document.body.appendChild(tooltipEl)
        }

        // Hide if no tooltip
        const tooltipModel = context.tooltip
        if (tooltipModel.opacity === 0) {
          tooltipEl.style.opacity = 0
          if (tooltipEl._hideOnTouchOutside) {
            document.removeEventListener("touchstart", tooltipEl._hideOnTouchOutside)
            tooltipEl._hideOnTouchOutside = null
          }
          return
        }

        // Set caret Position
        tooltipEl.classList.remove("above", "below", "no-transform")
        if (tooltipModel.yAlign) {
          tooltipEl.classList.add(tooltipModel.yAlign)
        } else {
          tooltipEl.classList.add("no-transform")
        }

        const width = 260

        tooltipEl.style.zIndex = "1010"
        tooltipEl.style.backgroundColor = "#27272A"
        tooltipEl.style.borderRadius = "12px"
        tooltipEl.style.padding = "12px 14px"
        tooltipEl.style.color = "white"
        tooltipEl.style.minWidth = width + "px"

        // Set Text
        if (tooltipModel.body) {
          const titleLines = tooltipModel.title || []

          let innerHtml = "<thead>"
          let styleTitle =
            "padding-bottom: 0px; text-align: start; font-weight: 500; color: #7A7A83"
          let styleTitle2 =
            "padding: 0px; padding-top: 12px; padding-bottom: 4px; font-weight: 400; text-align: start"
          let styleTitle3 = "padding: 0px; padding-top: 4px; font-weight: 400; text-align: start;"

          titleLines.forEach(function (value, i) {
            if (typeof value === "string" && value.startsWith("__RAW__")) {
              const cleaned = value.replace("__RAW__", "")
              innerHtml += '<tr><th style="padding:0;text-align:start;">' + cleaned + "</th></tr>"
              return
            }
            if (i === 0) {
              innerHtml += '<tr><th style="' + styleTitle + '" >' + value + "</th></tr>"
            }
            if (i === 1) {
              const dotStyle =
                "display: inline-block; width: 8px; height: 8px; border-radius: 50%; background-color: #225AEA; margin-right: 8px; margin-bottom: 2px;"
              innerHtml +=
                '<tr><th style="' +
                styleTitle2 +
                '" ><span style="' +
                dotStyle +
                '"></span>' +
                value +
                "</th></tr>"
            }
            if (i === 2) {
              const dotStyle =
                "display: inline-block; width: 8px; height: 8px; border-radius: 50%; background-color: #A1A1AA; margin-right: 8px; margin-bottom: 2px;"
              innerHtml +=
                '<tr><th style="' +
                styleTitle3 +
                '" ><span style="' +
                dotStyle +
                '"></span>' +
                value +
                "</th></tr>"
            }
          })
          innerHtml += "</thead><tbody>"

          let tableRoot = tooltipEl.querySelector("table")
          tableRoot.innerHTML = innerHtml
        }

        const position = context.chart.canvas.getBoundingClientRect()

        // Display, position, and set styles for font
        tooltipEl.style.opacity = 1
        tooltipEl.style.position = "absolute"

        let tooltipWidth = tooltipEl?.offsetWidth
        let deltaLeft = tooltipWidth / 2
        if (dataPoints?.chart.width - tooltipModel.caretX <= tooltipWidth / 2) {
          deltaLeft = tooltipWidth * 0.75
        } else if (tooltipModel.caretX < tooltipWidth / 2) {
          deltaLeft = tooltipWidth * 0.25
        }

        const tooltipHeight3 = tooltipEl?.offsetHeight || 140

        let left3 = position.left - deltaLeft + window.scrollX + tooltipModel.caretX
        let top3 = position.top - (tooltipHeight3 + 20) + window.scrollY + tooltipModel.caretY
        left3 = Math.max(
          window.scrollX,
          Math.min(left3, window.scrollX + window.innerWidth - tooltipEl.offsetWidth)
        )
        top3 = Math.max(
          window.scrollY,
          Math.min(top3, window.scrollY + window.innerHeight - tooltipHeight3)
        )
        tooltipEl.style.left = left3 + "px"
        tooltipEl.style.top = top3 + "px"
        tooltipEl.style.padding = tooltipModel.padding + "px "
        tooltipEl.style.pointerEvents = "none"

        if (!tooltipEl._hideOnTouchOutside) {
          const canvas = context.chart.canvas
          tooltipEl._hideOnTouchOutside = (e) => {
            if (!canvas.contains(e.target)) {
              tooltipEl.style.opacity = 0
              document.removeEventListener("touchstart", tooltipEl._hideOnTouchOutside)
              tooltipEl._hideOnTouchOutside = null
            }
          }
          document.addEventListener("touchstart", tooltipEl._hideOnTouchOutside, { passive: true })
        }
      }
    },
    legend: {
      display: false
    }
  }
})

export const countryChartOptions = (period, setHoverIndex, theme, isMobile) => ({
  responsive: true,
  maintainAspectRatio: false,
  // Room to the left of the y-axis labels for the country flags (country-flag-axis plugin).
  layout: { padding: { left: 32 } },
  interaction: {
    mode: "index"
    // intersect: false,
  },
  // stacked: false,
  indexAxis: "y",
  plugins: {
    title: {
      display: false
    },
    tooltip: {
      enabled: false,
      // yAlign: 'bottom',
      // displayColors: false,
      // boxHeight: 200,
      callbacks: {
        title: (context) => {
          const dataIndex = context?.[0]?.dataIndex
          const periodArr = period
          const count = context?.[0]?.dataset?.count[dataIndex]
          const volume = context?.[0]?.dataset?.volume[dataIndex]
          const countVolume = isIncognitoActive()
            ? INCOGNITO_MASK
            : `${formatNumber(count, 0, ",", ".")}` +
              '<span class="gray-circle"></span>' +
              `$${formatNumber(volume, 2, ",", ".")}`
          return [
            `${dayjs(periodArr?.[0]).format(dateFormat)}` +
              " - " +
              `${dayjs(periodArr?.[1]).format(dateFormat)}`,
            `${context?.[0].label}` + " " + '<span class="space-10"></span>' + countVolume
          ]
        }
      },
      external: function (context) {
        const dataPoints = context.tooltip.dataPoints?.[0]
        // Tooltip Element
        let tooltipEl = document.getElementById("chartjs-tooltip_country")

        // Create element on first render
        if (!tooltipEl) {
          tooltipEl = document.createElement("div")
          tooltipEl.id = "chartjs-tooltip_country"
          let styleTable = "width: 100%;"
          tooltipEl.innerHTML = '<table style="' + styleTable + '" ></table>'
          // need clear charts custom tooltip element from body of page (because it can not remove on other pages automatically)
          //this logic see in initComponent
          document.body.appendChild(tooltipEl)
        }
        // Hide if no tooltip
        const tooltipModel = context.tooltip
        if (tooltipModel.opacity === 0) {
          tooltipEl.style.opacity = 0
          if (tooltipEl._hideOnTouchOutside) {
            document.removeEventListener("touchstart", tooltipEl._hideOnTouchOutside)
            tooltipEl._hideOnTouchOutside = null
          }
          return
        }

        // Set caret Position
        tooltipEl.classList.remove("above", "below", "no-transform")
        if (tooltipModel.yAlign) {
          tooltipEl.classList.add(tooltipModel.yAlign)
        } else {
          tooltipEl.classList.add("no-transform")
        }

        const width = 236

        tooltipEl.style.backgroundColor = "#27272A"
        tooltipEl.style.borderRadius = "12px"
        tooltipEl.style.padding = "12px 12px"
        tooltipEl.style.color = "white"
        tooltipEl.style.minWidth = width + "px"
        // Set Text
        if (tooltipModel.body) {
          const titleLines = tooltipModel.title || []

          let innerHtml = "<thead>"
          let styleTitle =
            "padding-bottom: 0px; text-align: start; font-weight: 500; color: #7A7A83"
          let styleTitle2 = "padding: 0px; padding-top: 12px; font-weight: 400; text-align: start"

          titleLines.forEach(function (value, i) {
            if (i === 0) {
              innerHtml += '<tr><th style="' + styleTitle + '" >' + value + "</th></tr>"
            }
            if (i === 1) {
              innerHtml += '<tr><th style="' + styleTitle2 + '">' + value + "</th></tr>"
            }
          })
          innerHtml += "</thead><tbody>"

          let tableRoot = tooltipEl.querySelector("table")
          tableRoot.innerHTML = innerHtml
        }

        const position = context.chart.canvas.getBoundingClientRect()
        // Display, position, and set styles for font
        tooltipEl.style.opacity = 1
        tooltipEl.style.position = "absolute"

        let tooltipWidth = tooltipEl?.offsetWidth
        let deltaLeft = 32
        if (dataPoints?.chart.width - tooltipModel.caretX <= tooltipWidth / 2) {
          deltaLeft = tooltipWidth * 0.85
        }

        const tooltipHeight4 = tooltipEl?.offsetHeight || 86
        let left4 = position.left - deltaLeft + window.scrollX + tooltipModel.caretX
        let top4 = position.top - (tooltipHeight4 + 20) + window.scrollY + tooltipModel.caretY
        left4 = Math.max(
          window.scrollX,
          Math.min(left4, window.scrollX + window.innerWidth - tooltipEl.offsetWidth)
        )
        top4 = Math.max(
          window.scrollY,
          Math.min(top4, window.scrollY + window.innerHeight - tooltipHeight4)
        )
        tooltipEl.style.left = left4 + "px"
        tooltipEl.style.top = top4 + "px"
        tooltipEl.style.padding = tooltipModel.padding + "px "
        tooltipEl.style.pointerEvents = "none"

        if (!tooltipEl._hideOnTouchOutside) {
          const canvas = context.chart.canvas
          tooltipEl._hideOnTouchOutside = (e) => {
            if (!canvas.contains(e.target)) {
              tooltipEl.style.opacity = 0
              document.removeEventListener("touchstart", tooltipEl._hideOnTouchOutside)
              tooltipEl._hideOnTouchOutside = null
            }
          }
          document.addEventListener("touchstart", tooltipEl._hideOnTouchOutside, { passive: true })
        }
      }
    },
    legend: {
      display: false
    }
  },
  scales: {
    x: {
      display: true,
      type: "linear",
      grid: {
        display: true,
        color: theme === "dark" ? "rgba(255, 255, 255, 0.12)" : "#E1E1E2",
        tickColor: "transparent"
        // drawOnChartArea: false,
      },
      border: {
        display: false
      },
      ticks: {
        // stepSize: 1000,
        callback: function (value) {
          if (isIncognitoActive()) return INCOGNITO_MASK
          if (value >= 1000) return value / 1000 + "k"
          return value
        },
        font: {
          size: 12,
          weight: 400
        }
      }
    },
    y: {
      type: "category",
      // display: showFilteredTrafficScale,
      display: true,
      position: "left",
      // beginAtZero: true,
      grid: {
        display: false,
        tickColor: "transparent"
      },
      border: {
        display: false
      },
      // chart.js sizes this axis from the label widths it measured once, and it came up a few
      // pixels short: "United Kingdom" was painted wider than the space it was given and lost
      // its first letter off the left edge. Reserve room for the longest country name we
      // render. Mobile wraps its labels, so it needs less.
      afterFit: (scale) => {
        const minWidth = isMobile ? 60 : 132
        scale.width = Math.max(scale.width, minWidth)
      },
      ticks: {
        // Left-align the country labels so the flags (country-flag-axis plugin) line up in a
        // clean column to their left instead of riding ragged right-aligned text.
        crossAlign: "far",
        font: {
          size: !isMobile ? 14 : 12,
          weight: 500
        },
        color: theme === "dark" ? "#FCFCFC" : "#27272A",
        callback: function (value) {
          const label = this.getLabelForValue(value)
          if (!isMobile) return label
          if (typeof label !== "string" || label.length <= 5) return label
          const words = label.split(" ")
          const lines = []
          let currentLine = ""
          words.forEach((word) => {
            const candidate = currentLine ? `${currentLine} ${word}` : word
            if (candidate.length <= 5) {
              currentLine = candidate
            } else {
              if (currentLine) lines.push(currentLine)
              currentLine = word
            }
          })
          if (currentLine) lines.push(currentLine)
          return lines
        }
      }
    }
  },
  onHover: (event, chartElement) => {
    if (chartElement.length) {
      setHoverIndex(chartElement?.[0].index)
    } else {
      setHoverIndex(null)
    }
  },
  datasets: {
    line: {
      pointRadius: 0, // disable for all `'line'` datasets
      lineTension: 0.4
    }
  }
})

// The platform's chart tooltip: a dark card rendered into #chartjs-tooltip and floated
// above the caret. Extracted so every chart on this page shares one tooltip instead of
// some of them falling back to chart.js's built-in box, which looks nothing like it.
//
// The `title` callback supplies the lines: row 0 is the muted header (the date), row 1 is
// the headline value, and any further rows are detail. `iconForRow` decides whether a
// detail row carries a network logo, so a single-metric chart can reuse this untouched.
export function externalDarkTooltip({ theme, iconForRow }) {
  return function (context) {
    const dataPoints = context.tooltip.dataPoints?.[0]

    // Tooltip Element
    let tooltipEl = document.getElementById("chartjs-tooltip")

    // Create element on first render
    if (!tooltipEl) {
      tooltipEl = document.createElement("div")
      tooltipEl.id = "chartjs-tooltip"
      let styleTable = "width: 100%;"
      tooltipEl.innerHTML = '<table style="' + styleTable + '" ></table>'
      // need clear charts custom tooltip element from body of page (because it can not remove on other pages automatically)
      //this logic see in initComponent
      document.body.appendChild(tooltipEl)
    }
    // Hide if no tooltip
    const tooltipModel = context.tooltip
    if (tooltipModel.opacity === 0) {
      tooltipEl.style.opacity = 0
      if (tooltipEl._hideOnTouchOutside) {
        document.removeEventListener("touchstart", tooltipEl._hideOnTouchOutside)
        tooltipEl._hideOnTouchOutside = null
      }
      return
    }

    // Set caret Position
    tooltipEl.classList.remove("above", "below", "no-transform")
    if (tooltipModel.yAlign) {
      tooltipEl.classList.add(tooltipModel.yAlign)
    } else {
      tooltipEl.classList.add("no-transform")
    }

    const width = 154

    tooltipEl.style.zIndex = "1010"
    tooltipEl.style.backgroundColor = "#27272A"
    tooltipEl.style.borderRadius = "12px"
    tooltipEl.style.padding = "12px 12px"
    tooltipEl.style.color = "white"
    tooltipEl.style.minWidth = width + "px"
    // Set Text
    if (tooltipModel.body) {
      const titleLines = tooltipModel.title || []

      let innerHtml = "<thead>"
      let styleTitle = "padding-bottom: 0px; text-align: start; font-weight: 500; color: #7A7A83"
      let styleTitle2 =
        "padding: 0px; padding-top: 12px; padding-bottom: 12px; font-weight: 400; text-align: start"
      let styleTitle3 = "padding: 0px; padding-top: 4px; font-weight: 400; text-align: start;"

      titleLines.forEach(function (value, i) {
        if (i === 0) {
          innerHtml += '<tr><th style="' + styleTitle + '" >' + value + "</th></tr>"
          return
        }
        if (i === 1) {
          innerHtml += '<tr><th style="' + styleTitle2 + '" >' + value + "</th></tr>"
          return
        }
        const icon = iconForRow ? iconForRow(i) : null
        const logo = icon
          ? '<img src="' +
            Images[serviceImgTooltip[theme][icon]] +
            '" width="20" height="auto" style="margin-right: 8px;" alt="' +
            icon +
            ' logo">'
          : ""
        innerHtml += '<tr><th style="' + styleTitle3 + '">' + logo + value + "</th></tr>"
      })
      innerHtml += "</thead><tbody>"

      let tableRoot = tooltipEl.querySelector("table")
      tableRoot.innerHTML = innerHtml
    }

    const position = context.chart.canvas.getBoundingClientRect()
    // const bodyFont = Chart.helpers.toFont(tooltipModel.options.bodyFont);

    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1
    tooltipEl.style.position = "absolute"

    let tooltipWidth = tooltipEl?.offsetWidth
    let deltaLeft = tooltipWidth / 2
    if (dataPoints?.chart.width - tooltipModel.caretX <= tooltipWidth / 2) {
      deltaLeft = tooltipWidth * 0.75
    } else if (tooltipModel.caretX < tooltipWidth / 2) {
      deltaLeft = tooltipWidth * 0.25
    }

    const tooltipHeight2 = tooltipEl?.offsetHeight || 160
    let left2 = position.left - deltaLeft + window.scrollX + tooltipModel.caretX
    let top2 = position.top - (tooltipHeight2 + 20) + window.scrollY + tooltipModel.caretY
    left2 = Math.max(
      window.scrollX,
      Math.min(left2, window.scrollX + window.innerWidth - tooltipEl.offsetWidth)
    )
    top2 = Math.max(
      window.scrollY,
      Math.min(top2, window.scrollY + window.innerHeight - tooltipHeight2)
    )
    tooltipEl.style.left = left2 + "px"
    tooltipEl.style.top = top2 + "px"
    // tooltipEl.style.font = bodyFont.string;
    tooltipEl.style.padding = tooltipModel.padding + "px "
    tooltipEl.style.pointerEvents = "none"

    if (!tooltipEl._hideOnTouchOutside) {
      const canvas = context.chart.canvas
      tooltipEl._hideOnTouchOutside = (e) => {
        if (!canvas.contains(e.target)) {
          tooltipEl.style.opacity = 0
          document.removeEventListener("touchstart", tooltipEl._hideOnTouchOutside)
          tooltipEl._hideOnTouchOutside = null
        }
      }
      document.addEventListener("touchstart", tooltipEl._hideOnTouchOutside, { passive: true })
    }
  }
}

// Options for the KPI chart under the dashboard's metric tabs. The chart redraws from
// whichever block is selected, so the y ticks and the tooltip format follow that block's
// prefix instead of a page-level count/volume switch.
export const kpiChartOptions = (theme, block) => {
  const base = baseOptions(theme)
  const formatValue = (value) =>
    block?.prefix ? formatCurrency(value, true) : formatNumber(value, 0, ",", ".")

  // Total alerts carries a per-network split, so its tooltip is the same Total / Ethoca /
  // RDR / CDRN card the alerts overview has always drawn. The other metrics have no split
  // and show a single value, but through the same tooltip so they read as one family.
  const breakdown = block?.breakdown

  const buildTitle = (context) => {
    const point = context?.[0]
    const date = point?.label
    const value = point?.parsed?.y
    const displayValue = isIncognitoActive() ? INCOGNITO_MASK : formatValue(value)

    if (!breakdown) return [date, `${block?.label ?? ""}: ${displayValue}`]

    const row = (name, service) => {
      const amount = breakdown[service]?.[point?.dataIndex] ?? 0
      const displayAmount = isIncognitoActive() ? INCOGNITO_MASK : formatNumber(amount, 0, ",", ".")
      return `${name} <span style="float: right; padding-left: 8px">${displayAmount}</span>`
    }
    return [
      date,
      `Total: ${displayValue}`,
      row("Ethoca", "ethoca"),
      row("RDR", "rdr"),
      row("CDRN", "cdrn")
    ]
  }

  return {
    ...base,
    plugins: {
      title: { display: false },
      legend: { display: false },
      tooltip: {
        enabled: false,
        callbacks: { title: buildTitle },
        external: externalDarkTooltip({
          theme,
          iconForRow: breakdown ? (i) => (i === 2 ? "ethoca" : "rdr") : null
        })
      }
    },
    scales: {
      ...base.scales,
      x: {
        ...base.scales.x,
        ticks: { ...base.scales.x.ticks, maxTicksLimit: 10, autoSkip: true, maxRotation: 0 }
      },
      y: {
        ...base.scales.y,
        ticks: {
          ...base.scales.y.ticks,
          // baseOptions abbreviates to "18.8k"; the platform spells numbers out.
          callback: (value) => (isIncognitoActive() ? INCOGNITO_MASK : formatValue(value))
        }
      }
    }
  }
}
